import { Typography } from '@mui/material';
import { useAuthStateSuspenseQuery } from 'generated/graphql';
import {
  Navigate,
  Outlet
} from 'react-router-dom';



export type PrivateRouteProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PrivateRouteProps) => {
  const queryTuple = useAuthStateSuspenseQuery({
    returnPartialData: false
  });


  if (queryTuple.data?.loggedInUser?.person && !queryTuple.data.loggedInUser.person.isActive) {
    return (
      <Typography variant='h3'>Your Account has been disabled please contact your admin</Typography>
    );
  }


  if (queryTuple.data?.authStatus === 'signedIn') {
    return <Outlet />;
  }


  return <Navigate to='/auth/login' replace />;


};

